/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Roles_CountInputs */

const en_admin_roles_count = /** @type {(inputs: Admin_Roles_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} roles defined`)
};

const zh_admin_roles_count = /** @type {(inputs: Admin_Roles_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 个角色`)
};

/**
* | output |
* | --- |
* | "{count} roles defined" |
*
* @param {Admin_Roles_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_count = /** @type {((inputs: Admin_Roles_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_count(inputs)
	return zh_admin_roles_count(inputs)
});
export { admin_roles_count as "admin.roles.count" }